import React from "react"

const TopArrowIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99844 16.3734C7.5651 16.3734 7.19444 16.2194 6.88644 15.9114C6.57777 15.6028 6.42344 15.2318 6.42344 14.7984V5.67344L2.97344 9.12344C2.65677 9.4401 2.2861 9.59844 1.86144 9.59844C1.4361 9.59844 1.0651 9.4401 0.748437 9.12344C0.431771 8.80677 0.273438 8.43177 0.273438 7.99844C0.273438 7.5651 0.431771 7.1901 0.748437 6.87344L6.89844 0.723437C7.0651 0.556771 7.2401 0.440104 7.42344 0.373437C7.60677 0.306771 7.79844 0.273438 7.99844 0.273438C8.19844 0.273438 8.39444 0.306771 8.58644 0.373437C8.77777 0.440104 8.94844 0.556771 9.09844 0.723437L15.2484 6.87344C15.5651 7.1901 15.7234 7.5651 15.7234 7.99844C15.7234 8.43177 15.5651 8.80677 15.2484 9.12344C14.9318 9.4401 14.5611 9.59844 14.1364 9.59844C13.7111 9.59844 13.3401 9.4401 13.0234 9.12344L9.57344 5.67344V14.7984C9.57344 15.2318 9.41944 15.6028 9.11144 15.9114C8.80277 16.2194 8.43177 16.3734 7.99844 16.3734Z"
        fill="#E95444"
      />
    </svg>
  )
}

export default TopArrowIcon
